import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {URLSearchParams} from "@angular/http";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {Procedure} from "../domain/procedure";

@Injectable()
export class AgendaService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findProcedure(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.procedures.length > 0) {
            if (filter.procedures[0].type && filter.procedures[0].type.id) {
                params.set('procedures[0].type.id', filter.procedures[0].type.id);
            }
            if (filter.procedures[0].expirationDateSince && filter.procedures[0].expirationDateUntil) {
                params.set('procedures[0].expirationDateSince', filter.procedures[0].expirationDateSince);
                params.set('procedures[0].expirationDateUntil', filter.procedures[0].expirationDateUntil);
            }
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("agenda/procedures", params);
    }

    public resolveProcedure(procedureId: string): Observable<Procedure> {
        return this.backendService.get("agenda/procedure/" + procedureId, null);
    }

    private static setParams(filter: Vehicle, page: number, itemsPerPage: number, withDocuments?: boolean): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.procedures.length > 0 && filter.procedures[0].type && filter.procedures[0].type.id) {
            params.set('procedures[0].type.id', filter.procedures[0].type.id);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));

        /*Opcional: descarga de documentos*/
        params.set('withDocuments', String(withDocuments));
        return params;
    }

    public static getURLFilterProcedures(filter: Vehicle, page: number, itemsPerPage: number, withDocuments: boolean): string {
        return "/agendaReport?" + AgendaService.setParams(filter, page, itemsPerPage, withDocuments).toString();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/agenda.service.ts
 **/